<template>
    <!--  书信往来-->
    <div class="taoist">
        <!-- 展示列表 -->
        <div
            @click="linkToDetail(item)"
            class="content flex-between"
            v-for="(item,index) in contentList"
            :key="index"
        >
            <div class="titleName oneLine">{{item.news_title}}</div>
            <div class="time">{{item.data}}</div>
        </div>
        <!-- 分页 -->
        <div class="pageBar">
            <div class="block">
                <el-pagination
                    :pager-count="3"
                    @current-change="handleCurrentChange"
                    background
                    :page-size="page.per_page"
                    layout=" prev, pager, next"
                    :total="page.total"
                    :prev-text="$t('preText')"
                    :next-text="$t('nextText')"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeBeforeDay } from "../../common/js/common";
import { getLetterList } from "../../api/apis";
export default {
    name: "",
    components: {},
    props: ["cateId","title"],
    data() {
        return {
            page: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1
            },
            contentList: [
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // }
            ]
        };
    },
    methods: {
        handleCurrentChange(e) {
            this.page.current_page = e;
            this.getLetter();
        },
        linkToDetail(item) {
            this.$router.push({
                path: "/articleDetail",
                query: { name: "letter", id: item.id,title:this.title }
            }); //跳转到心得详情
        },
        //获取展示数据
        getLetter() {
            getLetterList(this.cateId, {
                limit: this.page.per_page,
                page: this.page.current_page
            }).then(res => {
                this.page.total = res.total;
                this.page.current_page = res.current_page;
                this.page.last_page = res.last_page;
                // this.contentList = getTimeBeforeDay(res.data,'data');
                this.contentList = res.data;
            });
        }
    },
    mounted() {
        this.getLetter();
    }
};
</script>

<style scoped>
.taoist {
    color: #333333;
}

.title {
    padding: 0.64rem;
}

.navItem {
    line-height: 1.1rem;
    color: #047bcdff;
    margin: 0.64rem;
 
    
}

.navItemActive {
    border-bottom: 0.11rem solid #047bcdff;
    color: #333333;
}

.titleLeft {
    font-size: 0.8rem;
    line-height: 1.8rem;
}
.titleName{
    width:15rem;
}

.content {
    /* height: 2.4rem; */
    border-bottom: 1px dashed #dfdfdf;
    line-height: 1.8rem;
    margin-left: 0.64rem;
    margin-right: 0.64rem;
    font-size: 0.85rem;
}
.time {
    color: #999999;
    font-size: 0.6rem;
}
.pageBar {
    margin-top: 3.5rem;
    text-align: center;
}
</style>